import { RadioCard, Tooltip, TooltipContent, TooltipProvider, TooltipRoot } from "@blurb/codex-react";
import { RpiLabelText } from "@rpi/openapi-core";
import { getDisplayName } from "./attributeValueMappings";

// Configuration for Text cards
export type TextCardProps = {
  value: string;
  displayName: string;
  disabled?: boolean;
  renderTooltip?: () => JSX.Element;
};

export const defaultGetTextCardConfig =
  (attributeKey: string): ((value: string) => TextCardProps | undefined) =>
  (value) => {
    if (!attributeKey) return undefined;

    const displayName = getDisplayName(attributeKey, String(value));

    if (!displayName) return undefined;

    return {
      value: String(value),
      displayName,
    };
  };

export const TextCard = ({ value, displayName, disabled = false, renderTooltip }: TextCardProps) => {
  const card = (
    <RadioCard value={value} disabled={disabled} data-testid={value}>
      <RpiLabelText>{displayName}</RpiLabelText>
    </RadioCard>
  );

  if (renderTooltip) {
    return (
      <TooltipProvider>
        <TooltipRoot>
          <Tooltip content={<TooltipContent>{renderTooltip()}</TooltipContent>}>
            <span style={{ display: "inline-block" }}>{card}</span>
          </Tooltip>
        </TooltipRoot>
      </TooltipProvider>
    );
  }

  return card;
};
